import { render, staticRenderFns } from "./contend.vue?vue&type=template&id=5dbc56aa&"
import script from "./contend.vue?vue&type=script&lang=js&"
export * from "./contend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports